import React from 'react';
import './ui.css';

/**
 * FeatureCard
 * Props come from constants/features.js
 */
function FeatureCard({ icon, iconBg, title, description, className = '' }) {
  return (
    <div className={`feature-card ${className}`}>
      <div className={`feature-card__icon feature-card__icon--${iconBg}`}>
        <span role="img" aria-hidden="true">{icon}</span>
      </div>
      <h3 className="feature-card__title">{title}</h3>
      <p className="feature-card__desc">{description}</p>
    </div>
  );
}

export default FeatureCard;